<template>
    <TextEditor class="link-text" :value="value" :hiddenBtns="hiddenBtns" :placeholder="placeholder" @change="changeHandler" />
</template>

<script>
import TextEditor from "@/views/zhiji/components/textEditor/Editor";

export default {
    name: "LinkWordText",
    props: ["value", "hiddenBtns", "placeholder"],
    components: {
        TextEditor
    },
    data() {
        return {
            innerValue: this.value
        };
    },
    watch: {
        value() {
            this.innerValue = this.value;
        }
    },
    methods: {
        changeHandler(val) {
            this.innerValue = val;
            this.$emit("input", this.innerValue);
        }
    }
};
</script>

<style lang="less" scoped>
.link-text {
    width: 100%;
    height: 224px;
    border: 1px solid #d8e4f0 !important;
    margin-bottom: 20px;
}
</style>
